import { ChevronLeft } from "lucide-react";

interface Props {
  label: string;
  onClick: () => void;
  className?: string;
}

/**
 * 스테이지 좌상단 뒤로가기 — 라벨 없는 원형 아이콘(1px 아웃라인 + 1.6 stroke 선, 스텝퍼 원과 같은 언어).
 * 라벨은 aria-label/title 로만. 크기·배치는 `.back`(globals.css) 과 호출부 modifier(`.capture__back` 등)가 정한다.
 */
export function BackButton({ label, onClick, className }: Props) {
  return (
    <button
      type="button"
      className={className ? `back ${className}` : "back"}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <ChevronLeft strokeWidth={1.6} aria-hidden />
    </button>
  );
}
